import {
  Box,
  Flex,
  Heading,
  Text,
  Image,
  UnorderedList,
  ListItem,
  VStack,
} from "@chakra-ui/react";

export default function FeatureShowcase() {
  const sections = [
    {
      title: "Explore Hafele’s New Digital Home",
      desc: "Hafele India, a trusted subsidiary of the global Hafele network for over two decades, is a leader in architectural hardware, furniture, & kitchen fittings excelling in quality products, strong networks and customer service.",
      features: [
        "Kitchen Solutions",
        "Lighting Solutions",
        "Furniture Fittings",
        "Appliances",
      ],
      logo: "/hafele.png",
      img: "/hafele-explore.png",
      reverse: false,
    },
    {
      title: "Innovative Plywood, Since 1957",
      desc: "Duro is carrying forward its rich legacy of 60+ years helping you design your dream home with high-performing innovative plywood.",
      features: [
        "Exclusive Duro Doors",
        "Decorative Veneers",
        "Durable Plywood",
        "Boards & Flush Doors",
      ],
      logo: "/duro.png",
      img: "/duro-explore.png",
      reverse: true,
    },
    {
      title: "Our Luxurious Bathroom Collections",
      desc: "Experience the ultimate elegance with our luxurious bathroom collections. Elevate your daily routine with exquisite designs and premium features.",
      features: [
        "Premium Kohler Bath Fittings",
        "Sanitary Ware",
        "Showers",
        "Basins",
        "Faucets",
        "Kitchen Sinks",
      ],
      logo: "/kohler.png",
      img: "/kohler-explore.png",
      reverse: false,
    },
  ];

  return (
    <Box maxW="1200px" mx="auto" bg="white" py={16} px={{ base: 4, md: 12 }}>
      <VStack spacing={20} align="stretch">
        {sections.map((sec, idx) => (
          <Flex
            key={idx}
            direction={{
              base: "column",
              md: sec.reverse ? "row-reverse" : "row",
            }}
            align="center"
            gap={10}
          >
            {/* Text Section */}
            <Box flex="1">
              <Heading as="h3" size="lg" mb={4}>
                {sec.title}
              </Heading>
              <Text color="gray.600" mb={6}>
                {sec.desc}
              </Text>

              <Heading as="h5" size="sm" mb={2}>
                Features
              </Heading>
              <UnorderedList spacing={1} mb={6}>
                {sec.features.map((f, i) => (
                  <ListItem key={i}>{f}</ListItem>
                ))}
              </UnorderedList>

              <Image
                src={sec.logo}
                alt={`${sec.title} logo`}
                h="30px"
                objectFit="contain"
              />
            </Box>

            {/* Image Section */}
            <Box flex="1">
              <Image
                src={sec.img}
                alt={sec.title}
                w="100%"
                h={{ base: "220px", md: "400px" }}
                objectFit="contain"
                borderRadius="md"
                boxShadow="sm"
              />
            </Box>
          </Flex>
        ))}
      </VStack>
    </Box>
  );
}
